import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, SimpleChanges, OnChanges } from '@angular/core';
import { EmailPreviewRequest } from '../../../../models/email/EmailPreviewRequest';
import { EmailPreviewResponse } from '../../../../models/email/EmailPreviewResponse';
import { Subscription } from 'rxjs';

import { AddReceivingLogRequest } from '../../../../models/logs/AddReceivingLogRequest';
import { LogEntryPhoto } from '../../../../models/logs/photos/LogEntryPhoto.interface';
import { EmailService } from '../../../../service/email.service';
import { AssetsDataService } from '../../../../service/assets-data.service';

import { PhotoService } from '../../../../service/photo.service';
import { copyPhotosToClipboard } from '../../../../helpers/copy-photos';
import { convertAzurePhotosToLogEntryPhotos } from '../../../../shared/helpers/photos-utils';
import { ToastService } from '../../../../service/toast.service';
import { PhotoMetadata } from '../../../../models/logs/photos/PhotoMetadata';
import { LogEntryPhotoFile } from '../../../../models/logs/photos/LogEntryPhotoFiles.interface';

@Component({
  selector: 'app-preview-email-modal',
  templateUrl: './preview-email-modal.component.html',
  styleUrls: ['./preview-email-modal.component.css']
})
export class PreviewEmailModalComponent implements OnInit, OnDestroy, OnChanges{
  @Input() isOpen: boolean = false;
  @Input() includePhotosInEmail: boolean = true;
  @Input() logEntryId: number | undefined = undefined;
  /** True when the log being previewed had an accompanying expediting email. */
  @Input() hasExpeditingEmail: boolean = false;
 
  @Output() closeModal = new EventEmitter<void>();
  @Output() sendEmail = new EventEmitter<{request: AddReceivingLogRequest, photos: LogEntryPhoto[]}>();
  @Output() togglePhotosInEmail = new EventEmitter<boolean>();

  private loadingSubscription?: Subscription;
  private emailContentSubscription?: Subscription;
  private photosLoadedSubscription?: Subscription;
  private _emailService!: EmailService;

  private _photoService!: PhotoService;
  private _toastService!: ToastService;

  public isLoading: boolean = false;
  public loadingMessage: string = '';
  public isSending: boolean = false;
  public emailContent: EmailPreviewResponse = new EmailPreviewResponse();
  public photos: LogEntryPhoto[] = [];
  public logRowPhotos: PhotoMetadata[] = [];
  public photosLoading: boolean = false;

  constructor(
    emailService: EmailService, 
    assetsDataService: AssetsDataService,
    photoService: PhotoService,
    toastService: ToastService
  ) {
    this._emailService = emailService;
    this._photoService = photoService;
    this._toastService = toastService;
  }

  ngOnInit(): void {
    // Subscribe to loading state changes
    this.loadingSubscription = this._emailService.dataLoading.subscribe(loading => {
      this.isLoading = loading.isLoading;
      this.loadingMessage = loading.message || '';
    });

    this.emailContentSubscription = this._emailService.emailMessageData.subscribe(content => {
      this.emailContent = content;
    });

    // Subscribe to logRowPhotos changes
    this._photoService.logRowPhotos$.subscribe(photos => {
      this.logRowPhotos = photos;
    });

    this.photosLoadedSubscription = this._photoService.dataLoading.subscribe(loading => {
      this.photosLoading = loading.isLoading;
    });
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen']) {
      this.isOpen = changes['isOpen'].currentValue;
    }
    if (changes['logEntryId']) {
      this.logEntryId = changes['logEntryId'].currentValue;
    }
  }

  ngOnDestroy(): void {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
    }
    if (this.emailContentSubscription) {
      this.emailContentSubscription.unsubscribe();
    }
  }

  onClose(): void {
    this.closeModal.emit();
  }

onSendEmail(): void {

    this.sendEmail.emit();
 
  }

  onTogglePhotosInEmail(event: any): void {
    this.togglePhotosInEmail.emit(event);
    this.includePhotosInEmail = event.detail.checked;
  }



  onPopoutEmail(): void {
    // Get the log entry ID from either the email content or whatever source you have

    this.openEmailPopout();
    const photosOnLog = this._photoService.getLogRowPhotos().length>0;
if (photosOnLog) {
  this._toastService.showWarningMessage('Your email popout will open momentarily. Photo Attachments are NOT included in email popouts - you will need to manually add them to your email.');

}

  
 
    // if (this.logEntryId && photosOnLog) {
    //   // Show loading toast
    //   this._toastService.showWarningMessage('Fetching photos...');
      
    //   const copyToClipboard = true;
    //   // Use the PhotosService to fetch the photo files
    //   this._photoService.getPhotoFilesForLogEntry(this.logEntryId, copyToClipboard);
  // }
} 
  
  
  
  // Open email popout
  private openEmailPopout(): void {
    // Create mailto link with all recipients (including sender)
    const allRecipients = [...this.emailContent.recipients, this.emailContent.senderEmail].join(';');

      //  // Add photo availability message with HTML formatting
      //  const photoMessage = '(NOTE: Photos are not included with this email. If you would like to receive the photos, please reply to this email and we will arrange to send them to you separately)\n\n';


    // Convert your HTML to plaintext
    const plainTextBody =  this._emailService.createPlainTextEmailBody(this.emailContent.htmlBody);

 
    const mailtoLink = `mailto:${allRecipients}?subject=${encodeURIComponent(this.emailContent.subject)}&body=${encodeURIComponent(plainTextBody )}`;
    
    // Open email client
    window.open(mailtoLink, '_blank');
  }

}